import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PoeDataService } from '../service/poe-data.service';
import { Utility } from '../app.utility';
import { CacheDataStorage } from '../models/request/CacheDataStorage';
import { PayOnEmailService } from '../service/pay-on-email.service';
import { Invoices } from '../models/request/Invoices';
import { ActivatedRoute, Router } from '@angular/router';
import { PACResponse } from '../models/request/PACResponse';
import { ReviewMemcache } from '../models/request/ReviewMemcache';
import { DateModule } from '../util/DateModule';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MetadataResponse } from '../models/request/MetadataResponse';
import { Metadata } from '../models/request/Metadata';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  largeDialogVisible = false;
  poeHeader: any;
  poeFooter: any;
  poeContact: any;
  paymentDate: any;
  accountName: any;
  accountNumber: any;
  paymentMethod: any;
  documents: Invoices[];
  subtotal: string;
  convenience: number = 0.00;
  totalAcount: string;
  totalDocuments: string;
  uniqueToken: any;
  ConfirmationDate: string;
  confirmationNumber: string;
  spReason: boolean = false;
  status: boolean = false;
  accessToken: string;
  isConvenienceLableShow = true;
  strinVla: string;
  _customConvenienceFeeACH: string;
  _customConvenienceCC: string;
  _customConvenienceFeeLabel: string = "Convenience Fee:";
  isCustomConvenienceLableShow: boolean = false;
  currencyType: string;
  currencyVal: string;
  gobackButton: boolean = false;
  constructor(
    private sanitizer: DomSanitizer,
    private PoeDataService: PoeDataService,
    private util: Utility, private PayOnEmailService: PayOnEmailService, private route: ActivatedRoute, private router: Router,
    private dateModule: DateModule
  ) {
    this.uniqueToken = encodeURIComponent(this.route.snapshot.paramMap.get('uniquetoken'));
    if (this.route.snapshot.params.status == "success")
      this.status = true;
    else
      this.status = false;
    this.GetAccessToken();
    this.dateModule = dateModule;
  }
  GetAccessToken() {
    this.PoeDataService.GetAccessToken().subscribe(data => {
      this.accessToken = data;
    });
  }
  cols = [
    {
      field: 'invoiceNumber',
      header: 'Invoice',
      sortable: false,
      filterable: false
    },
    {
      field: 'poNumber',
      header: 'PO Number',
      sortable: false,
      filterable: false
    },
    {
      field: 'dueDate',
      header: 'Due Date',
      sortable: false,
      filterable: false
    },
    {
      field: 'totalDue',
      header: 'Invoice Amount',
      sortable: false,
      filterable: false
    },
    {
      field: 'paidOnline',
      header: 'Paid Online',
      sortable: false,
      filterable: false
    },
    {
      field: 'payAmount',
      header: 'Paid Amount',
      sortable: false,
      filterable: false
    }
  ];

  ngOnInit() {

    let keys: Array<string> = ["PACCacheResponse", "documentmetadata", "reviewmetadata"];
    this.PayOnEmailService.GetMemcaches(keys, this.accessToken).subscribe(data2 => {
      if (data2.status === 200) {
        let result: any = JSON.parse(data2.body.memcachedValues);
        if (result.PACCacheResponse) {
          let pacResponse: PACResponse = JSON.parse(result.PACCacheResponse.replace(/\\/g, "")) as PACResponse;
          this.paymentMethod = pacResponse.accountType;
          this.DisplayCustomConveniencFee(pacResponse.paymentType);
          this.paymentDate = this.checkDateFormate(pacResponse.paymentDate);
        }
        if (result.documentmetadata) {
          let cacheDataStorage: CacheDataStorage = JSON.parse(result.documentmetadata) as CacheDataStorage;
          this.accountName = cacheDataStorage.AccountName;
          this.accountNumber = cacheDataStorage.AccountNumber;
          
          
          if(cacheDataStorage.EnableFlexbilePay){
            this.gobackButton = true;
            this.totalDocuments = cacheDataStorage.flextTotalDocument;
          }else{
            this.totalDocuments = cacheDataStorage.TotalDocuments;
          }          
          this.poeHeader = (cacheDataStorage.Header) ? this.sanitizer.bypassSecurityTrustHtml(cacheDataStorage.Header) : "";
          this.poeFooter = (cacheDataStorage.Footer) ? this.sanitizer.bypassSecurityTrustHtml(cacheDataStorage.Footer) : "";
          this.poeContact = (cacheDataStorage.PoeContact) ? this.sanitizer.bypassSecurityTrustHtml(cacheDataStorage.PoeContact) : this.sanitizer.bypassSecurityTrustHtml("<h3 style=\"color:red;\">*Contact Information Unavailable*</h3>");
        }

        if (result.reviewmetadata) {
          let reviewMemcache: ReviewMemcache = JSON.parse(result.reviewmetadata) as ReviewMemcache;
          this.confirmationNumber = reviewMemcache.ConfirmationNumber;
          let now = this.dateModule.getDate();
          this.ConfirmationDate = this.checkDateFormate(now);
          this.convenience = reviewMemcache.ConvenienceFee;
          if (this.convenience == 0 || this.convenience == 0.00) {
            this.isConvenienceLableShow = false;
          }
          else {
            this.isConvenienceLableShow = true;
          }
          this.subtotal = reviewMemcache.Subtotal;
          this.totalAcount = reviewMemcache.TotalBalance;
          this.currencyVal = reviewMemcache.Currency;
          if(reviewMemcache.Currency == "CAD"){
            this.currencyType = "(CAD) ";
          }

          
          let invoics: Invoices[] = JSON.parse(reviewMemcache.ReviewDocuments.replace(/\\/g, "")) as Invoices[];
          invoics.forEach((row, index) => {
            invoics[index].dueDate = this.checkDateFormate(row.dueDate);
            invoics[index].totalDue = this.formatNumber(row.totalDue);
            invoics[index].payAmount = this.formatNumber(row.payAmount);
            invoics[index].paidOnline = this.formatNumber(row.paidOnline);
            invoics[index].invoiceNumber = row.invoiceNumber;
            invoics[index].poNumber = row.poNumber;

            if (invoics[index].shortPayreason != "" || invoics[index].shortPayText != "") {
              this.spReason = true;
              if (invoics[index].shortPayText != '') {
                invoics[index].checkDetails = invoics[index].shortPayText.slice(0, 20) + (invoics[index].shortPayText.length > 20 ? "..." : "");
                invoics[index].checkVal = invoics[index].checkDetails;
              } else {
                invoics[index].checkDetails = '';
                invoics[index].checkVal = row.shortPayreason;
              }
            }
          });
          if (this.spReason) {
            this.cols.push({ field: 'shortPayreason', header: 'Reason', sortable: false, filterable: false });
          }
          this.documents = invoics;
        }
        this.ClearMemcache();
      }
      else this.router.navigate(['/errors']);
    },
      error => {
        console.log(`Clearmemcache: ${error}`);
        this.router.navigate(['/errors']);
      });
  }


  checkDateFormate(date) {
    return this.util.dateFormate(date);
  }
  formatNumber(num: any) {
    return this.util.formatNumber(num);
  }
  ClearMemcache() {

    let keys: Array<string> = ["documentmetadata", "reviewmetadata", "PAC_Form_Data", "PACCacheResponse", "MetaDataFullResponse"];
    this.PayOnEmailService.RemoveMemcache(keys, this.accessToken).subscribe(data2 => {
      if (data2.status === 200) {
        console.log("Success");
      }
    },
      error => {
        console.log(`Clearmemcache: ${error}`);
        this.router.navigate(['/errors']);
      });
  }

  DownloadFormateCheck() {

    let documents = this.documents;

  }

  downloadPDF(action) {
    const documentDefinition = this.getDocumentDefinition();
    switch (action) {
      case 'open': pdfMake.createPdf(documentDefinition).open(); break;
      case 'print': pdfMake.createPdf(documentDefinition).print(); break;
      case 'download': pdfMake.createPdf(documentDefinition).download(this.accountName + '_' + this.accountNumber + '.pdf'); break;

      default: pdfMake.createPdf(documentDefinition).open(); break;
    }
  }
  headerPDF() {
    var statusText;
    if (this.status) {
      statusText = 'Confirmation'
    } else {
      statusText = 'Transaction has been failed';
    }

    return {
      text: statusText,
      bold: true,
      fontSize: 16,
      alignment: 'center',
    }

  }

  subHeaderPDF() {
    if (this.status) {
      return {
        text: 'Thank you for your payment\n\n',
        style: 'subheader'
      };
    } else {
      var dd = {
        text: [
          {
            text: "We apologize for this inconvenience\n If you need assistance,", fontSize: 10,
            bold: false,
            alignment: 'center',
            color: 'gray',
          },
          {
            text: 'Please Contact us.\n\n', fontSize: 10,
            bold: false,
            alignment: 'center',
            color: '#169BD5',
          }
        ]
      };
      return dd;
    }
  }
  getDocumentDefinition() {

    var dd = {
      pageMargins: [10, 10, 10, 10],
      content: [
        [
          this.getConfirmPicObject()
        ],
        this.headerPDF(),
        this.subHeaderPDF(),
        {
          style: 'bigger',
          columns: [

            {
              text: 'Confirmation Number. ',
              style: 'confirmDetails'
            },
            {
              text: 'Confirmation Date ',
              style: 'confirmDetails'
            },

          ]
        },
        {
          style: 'bigger',
          columns: [
            {
              text: this.confirmationNumber
            },
            {
              text: this.ConfirmationDate
            },

          ]
        },
        this.emptyLine(),
        {
          style: 'bigger',
          columns: [

            {
              text: 'Account. ',
              style: 'confirmDetails'
            },
            {
              text: 'Payment Date ',
              style: 'confirmDetails'
            },
            {
              text: 'Payment Method ',
              style: 'confirmDetails'
            }
          ]
        },
        {
          style: 'bigger',
          columns: [
            {
              text: this.accountName + '\n' + this.accountNumber
            },
            {
              text: this.paymentDate
            },
            {
              text: this.paymentMethod + '\n'
            }
          ]
        },
        '\n',
        this.getDocumentObject(),
        {
          columns: [
            { width: '*', text: '' },
          ]
        },
        '\n',
        {
          columns: [
            {
              text: 'Total Documents:' + this.totalDocuments,
            },
            this.getTotalObject(),
          ]
        },
        '\n',
        this.ShowCustomConvenienceFee(),
      ],
      info: {
        title: this.accountName + '_' + this.accountNumber,
        author: this.accountName,
        subject: 'PDF',
        keywords: 'Download_PDF',
      },
      styles: {

        tableHeader: {
          bold: false,
          fontSize: 12,
          color: 'gray',

        },
        tableHeader1: {
          fontSize: 10,
          color: 'black',

        },
        subheader: {
          fontSize: 14,
          bold: false,
          alignment: 'center',
        },
        subheader1: {
          fontSize: 10,
          bold: false,
          alignment: 'center',
          color: 'gray',
        },
        confirmDetails: {
          color: 'gray',
        },

      }

    }
    return dd;
  }

  emptyLine() {
    return {
      table: {
        widths: ['*'],
        body: [[" "], [" "]]
      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 0 : .001;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      }
    };
  }

  getDocumentObject() {

    let bodyTableData = [
      {
        text: 'Document',
        style: 'tableHeader1',
        bold: true,
      },
      {
        text: 'Po Number',
        style: 'tableHeader1',
        bold: true,
      },
      {
        text: 'Due Date',
        style: 'tableHeader1',
        bold: true,
      },
      {
        text: 'Amount',
        style: 'tableHeader1',
        bold: true,
      },
      {
        text: 'Paid Online',
        style: 'tableHeader1',
        bold: true,
      },
      {
        text: 'Pay Amount',
        style: 'tableHeader1',
        bold: true,
      },
    ];


    if (this.spReason) {
      var withTable = ['14%', '14%', '10%', '10%', '10%', '10%'];
    } else {
      var withTable = ['18%', '18%', '15%', '15%', '15%', '15%'];

    }

    if (this.spReason) {
      bodyTableData.push({
        text: 'Reason',
        style: 'tableHeader1',
        bold: true,
      });

      withTable.push('*');


    }

    let result = [];
    this.documents.forEach((row, index) => {
      var object1 = {
        'dueDate': (row.dueDate),
        'totalDue': (row.totalDue),
        'payAmount': (row.payAmount),
        'paidOnline': (row.paidOnline),
        'invoiceNumber': typeof  row.invoiceNumber!='undefined' &&  row.invoiceNumber ?  row.invoiceNumber : '',
        'poNumber': typeof row.poNumber!='undefined' && row.poNumber ? row.poNumber : ''
      }
      if (this.spReason) {
        var object2 = {};
        if ((row.showPay)) {
          object2 = { 'Reason': row.checkVal };
          var Data = Object.assign(object1, object2);
        } else {

          object2 = { 'Reason': "" };
          var Data = Object.assign(object1, object2);

        }
        result.push(Data)
      } else {
        result.push(object1);
      }

    });


    return {
      columns: [

        {

          color: 'grey',
          fontSize: 9,
          table: {
            heights: 25,
            style: 'tableExample',
            widths: withTable,
            body: [
              bodyTableData,
              ...result.map((row, index) => {
                var dataRow = [
                  row.invoiceNumber,
                  row.poNumber,
                  row.dueDate,
                  row.totalDue,
                  row.paidOnline,
                  row.payAmount,
                ];

                if (this.spReason) {
                  dataRow.push(row.Reason);
                }

                return dataRow;


              })
            ]
          },
          layout: {

            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? .001 : .001;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? .001 : .001;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 'grey' : 'grey';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 'grey' : 'grey';
            },
          }

        }
      ]
    }

  }

  getTotalObject() {

    var totalVal = [];
    let convenienceLable=this._customConvenienceFeeLabel;
    convenienceLable=convenienceLable.replace("&num;","#").replace("&apos;","'").replace("&amp;","&");
    let currencyVal = "";
    if(this.currencyType != undefined){
       currencyVal = this.currencyType;
    }
    if (this.isConvenienceLableShow) {
      totalVal = [
        ['Subtotal:', this.formatNumber(this.subtotal)],
        [convenienceLable, this.formatNumber(this.convenience)],
        [currencyVal+'Total Amount:', this.formatNumber(this.totalAcount)],
      ]
    } else {
      totalVal = [

        [currencyVal+'Total Amount:', this.formatNumber(this.totalAcount)],
      ]
    }


    return {

      columns: [

        { width: '*', text: '' },
        {
          width: 'auto',

          table: {
            headerRows: 0,
            body: totalVal,
          },
          layout: 'lightHorizontalLines'

        }
      ]

    }
  }

  ShowCustomConvenienceFee()
  {
    if (this.isCustomConvenienceLableShow) {
      let convenienceFeeText=this._customConvenienceFeeLabel + this._customConvenienceCC;
      convenienceFeeText=convenienceFeeText.replace("&num;","#").replace("&apos;","'").replace("&amp;","&");
      return {
        columns: [
          {
            color: 'grey',
            fontSize: 9,
            text: convenienceFeeText,
          }
        ]
      }
    }  
  }


  getConfirmPicObject() {
    if (this.status) {
      return {
        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAbYklEQVR42u2dfZSWZZ3HP/PMOI0jIUtEHmNZ1oOsS6wRkbLksVsyMyvfUpZ8t7Q0UzPXOK6H5fa4rhkZmUfFl9TA1SKzdMm3lJ4lJZcQWeIYEssiIXGQZmfnTNM0jo/7x+96mGGYl+flfr+/n3PmzHhk5nme676u7/W7ftfvpQGRDXyagAnAJGA8MMp9AYwGCv3+dQdQcj/3AF3u53b3vdP9/3b3vcN9deLTo8HODg0aglQs7jJNwGRgKjANONwt+AnuqymCd9PjxKDNCUQbsAvYAfw3sA7YBPT0e99CAiCqWOwFt3vPAGYCH3CLfgrQmoJP0QVscGLwq36i0AuUJAwSALHvgi/v7McCR7tFPzWiHT0qOvqJwgvASmc9SBAkALnc4ScAHvBR933CgHN61ukF1gLPAk+7n3vw9/omhAQgU4u+GZgOnAac5M7wBQ3OXtqAVU4MngW2Ab2yDiQAaV70rcBs4BTgU5jDToxMyfkMHgF+AGySZSABSNN5fjpwNnA6MFEDU/dRYQ3wMPAosEtiIAFI2sIvuN19LvBZmfeh0QU848TgKSwuQWIgAYhtt2/BPPdfdOf6Fg1MZOwBfgLcA6zDp1dDIgGIarcfD5wFXIhd12m3j/eIUARuxZyH3XIcSgDCWviTgcuBc4AxGpTEsR64E3MetkkIJABBLPyyU+9KzKnXqkFJPNuBB4DvAjvkJ5AA1LrwZwPXACdg9/giXbQDy4HFwGYJgQSgUlN/KnCd2/G18NNPB3C3EwJdI0oAhlz4E4GrgQvoS6UV2WGXE4F75SOQAJQXPphX/wuYg2+8pkXm2QzchDkLO/MsBA05X/ijseu8+ShMN2+UsASkG4Fn8OmWAORn8TdjsfkLMA+/yC+9WPzAQmBt3vwDDTlb+Lhz/g3APOTgE310AN/GAopy4x9ozNmufybwIPCRXH12UQnvcPPiOGALHjsoZt8aaMjBwi8n6tyEXes1aa6LEegElgCLgN1ZtgYaM774W7Gw3e8Bf49i9kVlNGNBYB8HtuGxLavWQENGF34BK6B5E+bs064vaqUbuA+7LdiZNWugMYOLvxm72nsQK66pXV/UQxPwIeCTwG/x+B+KvC0BSObiH4t5+G8ADtbcFQEyDivt9ic8NlDkTR0BkrPwAY4AbgOO11wVIdILPATMx2eXBCAZ5/0T3eI/TPNTRMQa4FJgfZqDhxpTvvhbga+4xf8ezUkRIe91R4KdeLxKkbckANEu/kPdwv8KFsQhRNSMwpyDB+LxEsX05RM0pHDhg3n373TfhUgCK4DL8dkmAQj3vO8B96N6+yKZfoELgVfSEi/QmLLFfzJW6+1QzTWRUL/AccAaPHZSlAAEtfibsE47S4B3aZ6JBPNurIbky3j8LulBQ40pWPzN2HXLYuCdml8iBYwBPgFswmNLkkWgMeGLvxX4GnA9cKDmlUgRo7D4lN/h8ZukJhM1Jnjxj8ZCeq9BhTtEOjkQ+BjQhsf6JIpAY0IX/xjgW1jPPRXuEGnmHVh4+h9drMBbEoDhF/8o4GbgYlS1WGSDJqzaUBse65JkCTQmbPG3YIU6v4zSeEX2ROBY4DU8NibFMdiYoMXfhIX1XgccoPkiMkgzMAe7HdicBBFoTMjiLziT/+sorl9kmxYnAi+54iI5FwBb/HOxcswHaX6IHHAQFjG4Go/X4xSBQgIW/wnA7ViXHiHywkSsWO20fFoAPgAfBpahfnwin4wDZuHxLEX+N28WwBFYVp8Se0SemQHchc+4/FgAVrzzPpTPLwRYKbtWPJ6LOlCoMYbF34zF9p+t5y7EXqYDv8fj5SivBxsiXvwFrFPPPSi+X4iBtGF1Bp+PqqBIIcLFjzP5F2nxCzEoY7FSd5FVu4rSCXio+3Dy+AsxNNOAW1xOTEZ8AJbXfyvWbFEIMTxHAD14vBB24lBjBIu/AFyBxfkrwUeIkWkAjgZeccVEUnoEsHP/HCzDTx16haicVqwM3pQ0+wDGYbn9CvMVonomAje6NPmUCYCl916NRToJIWrjVOCMsK4Fw7QAZmGFPYQQtdME3AhMCuOPh+MEtJp+y4C/1vMTom4OBsbh8dOgQ4ULISz+stf/KD03IQJjLnBq0EeBMI4AM93ZXwgRHM3uKDAhuUcAq+V/PyFfXQiRU8YCo/B4KqgAoUKAi78AXIJVPhVChMN5wIlBHQWCPAJMAebr+QgRKi3uKDAmOQJgd/7znYkihAiXI4HzgrACgrIAZgLz9FyEiIyrgUPq/SP1OwGtws8dwN/qmQgRGQdjGYPFeioIBWEBnOC+hBDRcglWTzAmC8CKFtxDhBVMhBB7ORArJvpkrdeChToWP8AZKOJPiDg5C3MKRmwBeIwFHoB46pkLAZSA14HN7qsdSz3PU3PZA4D34PHjWvIEaivSYUE/F6GIPxHfwt8A3AU8A+wButzinw5cBpyIFdXIAycBnhuLqmioUQAOAV4mgGsIIWqgCJyPz/Yh5mcLcDxWiWom+ShFtwr4GD494R4B7Oz/FeBkzUMRA5uBC/D57TDy0EuRzXisAN4E/g7Cq6qTEP4S+AVFtoYrAHb2vxeV+RLR0wFchs+qCu2ETjxWAf8JHA68l6ib4URHAzAWjx9WcyNQnWlku/85BJySKEQF9GIBZyuqnLO9+KwETgO+4UQkq5xAlTcC1VkAHqOxe/93aT6KiFkJXIlPV41egz/i8R/AeuB9ZNN/1QgcgMeKSqMDq3WOnIw8/yJ6tgPX4NNe118xa+AJ4NPAEqA7g2M1lyrqBzZWMXhNwG0o6k9ESzfwNeDJwBpkFOnA4zngNeyWIEv+rGbgTddqfEQroBoLYCZW6VeIqCgBy4EHAy+L7dMNLMW68Rbda2WF8yoVtcYKB6sA/AvwAc1JESG/AS7G5w+h/PUib1Pk93g8idWyOJJsxAwcBLxKkfVBWQCHAqdrPooI6QSuxWdb6K/ksxu4CngoQ+N3sTu21ykA/l7HwijNSRERvZiT7onIXtGnE7gF2JWRMTwKazVetwXQBJytOSkiZA1wEz69Eb/uRmBtRsawCbhwJN9JJQIw3X0JEQW7gavxaYv8lX1KWNRgVpjHCM7AQgXm/7nkI5lCxE8PsAh4Mcb3sCdD4zke+FQ9FkArVvRDiCh4FrgjrE64FTImY2N6rrvFq0kAjsFuAIQImx3A/JpDfYM5AhSAozM2rh7DlOsvjDAYn9W8FBHQDdyAz8aY38dUshfs1jLcMaAwwi+epLkpIuAnWHm5+PBpxQqIZDFJ6DNDHQMKI5gO4zU3RchsAa6rtpJNCMwlu0Vu5jCEb6MwhBqC5U8LESZdbvFvjfVd+EwBriO7VYNasRqJFVsATU41hAiLEhZ6+2jMi78FWAhMzvh4D3oMGEoAplBFTrEQNfAKsDCGaL+BzCMfeS7HD2bhFIb5xwr+EWHRiRX42JkA038B2S8YChYROGNkATAz4WOaoyJE038JNdSwD3jxtwI3UGdvvZQxpxILoAU4VvNUhMRaLNEn7gIcZwGn5mzsjxvoBxhMAGahkt8iHNqBq2JJ9Nl395+Kef2bczb+sxiQ1l8YMDAAH9c8FSHQCywm3kSfsum/kHw6uVsYEOlYGORIcLzmqgiB54FvJcD0n5dD078/Hx1OAMZTR6thIYZgD5bj35kA039BDk3//hzT3w8wUABmUGvHYCGGNv1vBNYlwPS/AcW3HNl/jQ8UAFX+EUFTBJbEmuNvr30eamgL5gScur8A2CB9UOMjAmQ31s4r7g4804BrZd3uZeZgFkBBFoAI2PS/Hgv5jXP3H+WOIOpo1ccHBxOAsTofiQB5Crg3Aab/BaiuxUCOKj+XwgDngOL/RRDsxLz+cef4HynTf8gjUctAAZihcREB0AMswGdzQkx/1bTcn2bgiIECIAegCIIVWNPNuE3/ixiiCIYALOXfCYANmByAol52ONM/7hz/GcB8mf7DMrm/BTCqrAhC1GH6z4+kmefwu/9o4CayWdwzSA7vLwCTkANQ1McjwPdjXvwF4Ason6VqC2CCxkPUwTaswk/ciT4znemvzUwCICI0/a9KQHmvMcDNwDg9koo4BJ/RZQHQoIlaKAEPAo8nwPT/MqpkVS2HlQXgXRoLUQNbMMdf3Kb/bOAqmf5VM14WgKiVbizRJ9522j5jsZbiY/VIqmZc/2tAIaox/e/F4v3jNv2vBI7SI6nND1AWABUBFdWwCQv3jZvZwBUy/WtmVHngmjUWokJ6gMvwaU+I6T9Gj6R2ZAGIak3/72BVfuI2/a+R6R+cAChmWlTCRuD6BJj+x2LXfjL9ZQGIiOgGLk5AZd/xwC3IcR2oALRoKMQIpv83gDUxL/4mZ/qrdoUEQERIuZ9f3MwBvqTHEbwACDEUnc70j7eyr5n+i4BWPRIJgIjO9L8enw0JMP0XoK5VEgARKc8D307A+zgBK/ElJAAiIjqc6R9veS+fQ7GuwvJThYDu/4NbLKuxENkurMnqMViZtTSKbAnL8ou7sm/Z9Fe5OglAYhfKo8Dl+OwaMHnL5akWkb4762eBJQl4HyfL9NcRIKl0AwuBs/db/CYAJXyWAOdDzHHz1dEGfD72Kz+fCViFH21SEoBEmvyXAv86Yvcbn0eBM7FGmWmwaK7GZ0fMi78Za+U9WVNNApA09gDnAg9UXAnH51ngMxBz3byReRyfBxLwPk4FztFUi04AujQUFbETOBOfx6s2kX2eB06BmOvmD81uZ9XEbfpPkukfvQD0aChGZDtwGn4dqbA+a50IbE2g6X/5oL6MaBd/C9bPb5KmW7QC0K6hGHHxn4kfQDKMRdWdgl0ZJoXl+CyPefEDnA7M03SLXgB6NRQRLP6+yb7RicArCTnWXJ6A9zHZmf7yS8UgAJ0aikHZFvji7xOBzcBpWJGNOE3/Lyagsm/Z9FeDmpgEoFtDsR+7gPNDWfz7isAngXUxfcYH8FmRANP/LOAMTTlZAEmh3e2MqyJYANudJRC1CGzHimvEzRTszl+mf/R0lAe9Q2Oxl14swi+6dlcmAqdg+QRRmf6X4tMW8+7fioVKH6ppF4+VWxaANo3FXp4A7o48FNai7z4TkQjc7T5n3Kb/eVi8v4iHtrIAvKGx2HsUWhxb9Ru7hw9bBDYD1yagvNc04HpNuVjZWRaAPRqLvYtjfcw7Y5gi0Iv5NuJu6jHKmf7jNeViowRsLQvADo0HAFtiXxzhikBSmnpcBJyo6RYrO/DpKgvAdo3H3iNAMugTgVVOretlA7AwIab/Ak212NkKfVcv21A+AMDYBCyQwURgZZ0i0O1M/7ibeozGynuplXcSrF32DQTapDFhKkm7krIovc/WKQLfBF5MgOl/CVbbX8TPq30CYLveeo0JhwFzEmUF9InAPwArahCBNSSjqcdM4DpNsWRaAAAva0xowhJSZidQBNqwQiTViEAnFvDTFfN7H4P181MPygQLwDqNCbgjwDJgegJFoMOJwCMViEAJS7BZF/N7LgBXYVWSRTLowq689xGADQTjbc7KUWAZcETi3pmJwIXA9xk+jduaevixvleAWcBXNaUSxQac07+/AHSUzQIB2HXVMnwOS6AIdDkRuG8IEegALou9n595+29FrbyTxrryxlAYYDLKEbgvM50ITEqgCPQAlwHfYt8r3BJ2z74x5vdXbuU9U9Mocfyq/ENhgLn2ksZmP2YD33V16pMmAr3AtVj2YtnR9wywJAGm/zHAFZo+CbUA2N8CQBbAkMwB7nd96pImAiXg61hF301Ycc+4g7rGOdNfrbyTRyf9Yn4GEwDVBxyc44E78TkkgSIAPkuBDxO3H8dM/+tQK++ksqH/Gh8oAHvQdeBwnAzclUgRsMXXlgDTfw4W8SeSyer+DW0GCkAJawwpRhYBpbLuz3jUyjvpPNf/PwqDKPjTGqOKROA2fMZpKPYx/Rdi+RQimXQzIMV8sEKMa1CjkEqYKxHYZ+M4EbXyTjprGJDyPpgA9BB30Yj0ME8iAFj49GKgWVMi0RQHNrQtDKLmJeBnGquqROBW/JzmuKuVd2rP/0NZAGCOQOUFVCcCN7ust7yZ/idj1X1FsukA1lYqAFtRXkA1FIDPAYtyJgITseKeauWdfFYySAewoQSg1/2CkAgMZ/rfhFp5p4UfDjz/Dy0AZtr9WGMmERhmfsxFrbzTQhfw1FATdiiex1pHC4nAQA5DrbzTZv63VysAXRBz51iJQBJ3/xasvJf6+aWHHw1m/g8vAGbm/UBjJxEYMCfOQf380kQ3w/SBHMmEW42ahkgE+piCOf5k+qeHIsO0/hvpQXYDyzWGEgHXynsxKPQ5ZSwbyvwfWQDM5Ps3VCMg3yJg8+BzwEl6lKliNyP48Sox5TaiGgF5FwG18k4ny7EIwCFpHPFPeJSw/G6pf/00ANOBd+PxC4qxV+2t1PRfitJ800YJ+BI+v6/PAjDz7xGUIpw/S8Ce/ZdRP780sgYr/0V9AtB3lpAzMH8iMAP180sr33NVowMQAPMi3oWcgfkRAZ9RwO2on18aaXNWO8EIgLEBWKWxDUUEFieqnoCZ/l/F2nqJ9LHUicCINFb8J4uU8OjE2lSL4Cg7Bv8Kj59T5E+xvyOP2cCdqMJPGukCLnIt5QO1AMAyijZojEOhXF4sXkvAjiO3o35+aeVRqqjlUa0AdGEdX0Q4nAXcHpsImOm/wFkkIn30uk2kFI4A2AR5BFULCtsSuD2mvgPHY9d+Ip08S5VBe41Vv4THn93vnajxDo1pwN/gUaS4bxnnEHf/ccCPQA1PUkoJuAKfzdX8UqGGiQLwIMoSDJvo2pD5FLAsvyka9tTyIjWU8681rXMPVhFGhC8CyyJoTX4ScIGGO9Vn/+vxqw8tr00A+qwA3QhEcy5fhh9S8U2zMG5HlX3TzFPU2MynnsIOHcCNqH9AFHjAD/A5IuDF34SV95qoIU4t3W7374lWAMwKeBwrHirC5ygnAjMCbAE+D1X2TTsPAetr/eXGul66SC8eO9wkatSzCJ33AB8Hfo3HaxR5uw4BnwYsA96pYU0t7cAF+LxR6x8IorbbKlQ9OEomAQ8Dc533vpbFPxEr+HqIhjPVLKHOmJz6d+0ib+GxFasWe4CeSSQchMVhFPBYR7GK85/PZCxZ5IMaxlSzA7gYf/iKP+ELAIDHbuCvsPxxEQ3NmHPw/Xj8Fx5vDOsH9mnG49PO7H+/hi/1LASeq+sYiGWiBYPtLL9EVWPjYCdwL/AYsM2dDUtYLv9YJ8yfd4LRquFKPRuBj+BXlvIblQAUgCuwayXVjY+HdmcadjgBGAWMASage/6s0A2cCawI4jaoIdC3ZlVkHkM15IQIiyXA5ZWU+4peAEwEZgI/czuPECI4NgPH4QfXtDcMU30dsEjPSohA6QHmE3DH7uAFwIoR3IH1FRRCBMNS4IkAo0BDOgL0CcExwJOotJQQ9bLVmf6Bp+CH6a1fDXxHz06IQEz/UOpvhCcAdhRYjPoKClEPy4HHgzb9o7AAwAqHXAP1hSsKkVO2AAtqTfWthHAz+IqAx2vAn7DCFgoQEqIyOrAqTS/VVuojCQJgIvA2HhuwXAHFoAsxMr3APwEP49cX6z8SDZF9JCs99RhW2EIIMTRLgUvx6Qr7hRoi/VgWJfjvKA9diKFYC5wSZLTfcER9Jl8HXA3VVy8VIgfsdjv/zqheMNoyXuYPeBU4EDhGz1uIvXRjXZmeqTfHP7kCYCLwFh4vAUcCh+u5CwHAt7G+fr1RvmhDbB/XCog8BkzVsxc55wng3CAKfCTdB9CfLcD5WAUbIfLKanfub4vjxeMr5V0EPHYCLwOfQElDIn9sAM7GZ2tcbyDeyDwfsMYiF0M8CihEjBbwuVBdN9/sWAB9lsDbeGwBXgdOwKrdCpFldgBnA2vDSvJJjwD0icArwB+wnAEVsBRZZQ/m+yrGvfiTIwAmAiWXM9ADHItajYns0QF8Afhp2DH+6RMAE4G38FgLvAOYhbIHRXboAq7EEnwS01E7ebusNRz9JRYtOFOWgMgAncA/Avfj81aS3lgyF1eRN/F4AXgTmC2fgEgxbViI79Koo/zSKwB9IvCiG0APNR4V6WM31pLtR0nb+ZMvAH0+gXVYQcTjgBbNKZEStmNXfT9L0pk/XQJgIlDC49eUu6JYa2whkswm4CzghaR4+9MrACYC5TTil5wIHKw5JhLKOmAesD4J9/wj0ZCqobUBPQrrcT9Fc00kbquCz8cZ259NC6D/8Hq8DqwE3gdM0pwTCaAEPAxcEkb3HgnAQBEo8gYeP8UyCN+PYgVEfHQ62/Sf8flD2t58ehdOkS48VmLdUj+MBQ4JESXbsGu+pfjprHOZ7p3TogZfBl5wvoHxmpMiIlZinv7VSb7mG4mGTDwKH4CJwC3A6SiHQIRHD7AEuD6uKj6yAAb3C/wfHk8DfwaORpGDInjasISeW/DpzMIHypbzrMifXQ7BRnck+AvNWREQa4FzsFTe3qx8qOx5zy1ycBPwEycAU9EtgaidTuCbWELP5qRH9uXTBzC0b6AZOAm4GQUOiep5EWtv/2KWdv38CICJAMChwAKs3bISisRIdGAO5e/g057lD9qQm0fq04QVHb0ZmKY5LoZgldv116b5ek8CMLQ1MB64DrgIaNV8F4424Cbgbnw68vKhG3L5qM0aOBZYiDUpVdxAfukBVgA3ABvysOtLAPqEoBU4GbgWa1Yq8kMJa0pzA7AKn548DkJD7qeBHQvGYHe812ARhSLbbHDm/uP4dOV5ICQA+wrBIcBlwJeAsRqUzLEdWAQ8CLSnoWCHBCB6IShgdQbmO6tAjsL00wbcAdwO7NLClwBUKgRHAldjCUYSgnQu/IeAxcC2vDn4JADBCcFk4FLgPB0NUsEO4B7gPmCnFr4EICghOASLJvwichYmkVeA24DlQJtMfQlAGEIAdmtwBlYNZibqXBQnPVj03l3AE0CXFr4EICohaAJmYO2ez0AViaJkG/B94HvAlqwm60gA0nM8GA18ylkFx8gqCIVu4Bngfvddu70EIHFi0IQ5DU8FTnMWgsSgPhN/NfAY8CiwQ049CUCajgiTnBicAsySGFS8069yi/5x5MmXAGTkmDDRHRM+iiUj6Uqxj51YbP7TmDNvtxa9BCDLYtAMTAeOx/odziJfwUbtbpf/OVbWdSNQ0qKXAORVEFqB2di14oecOEwkG6nKvVjH3HVYg9cXsYScHi14CYAY3H9QAMZhTsQZThSmAIeR7LJmHcAWt6O/5Bb9eqDL7fBCAiBqFAUwJ+IEJwRTgMOxW4cJWBzCuJAFohvY4762A5uB37odfqs7y5cGvGchARARisUYJwblr1FYnEKh3/eh6HG7dfl7W78FvyfrRTLzxv8DvSgNghC5DzwAAAAASUVORK5CYII=',
        width: 50,
        alignment: 'center'
      };
    } else {

      return {
        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIoAAABRCAYAAAANfj6IAAAABHNCSVQICAgIfAhkiAAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZiYm6UBoblZspkpiM8FAE+6FWgbLdiMAAAE3ElEQVR4nO2dTU8bVxSGX48/ZuLYjiAYiZAwMEQiH5LbdNNFF5Gy6y/pD6jaZbvotn8qUhdVpJbaUgKREsAGihRISKht5vqD6SIZxXLtegz2PeeM77MdxH01erjn3Dt3BsBgMBgMBoPBYBBKgjqALp4/KOY6jeMiAFzA3vm/n7WgPACwnZsn916+/UdHPu7EVpSyizVgtBRRCeX5oordSfw+acRKlM27uaLVrucmJccwLCgvE2T9+7Xm0TTH4UQsRCm7WJu2HMOwoLxZmGVEi0IpSD9xF0akKGFjykWSEAvKsx2c3HuJ2DXA4kThNIsMI46zixhRAsCquHC5SxJiQXmlVewnnqJDnWUSiBClsnJjrpvw31HnuBTp9OKjV/Vj6hhXxaIOMIqtleySWEkAoN1+U1nGbeoYV4W1KGUXa36i+zd1jqvSTdn74QagVNiWHglN67hIbnJZirK1kl2Kw0wyiGRH3Skd4oA6x7iwE0V04xoVgQ0uqx4lAKzYSwIA7fab4DFS1DHGgZUoFRcudQZdVPZwhzrDOLApPXFsXkchqbllIcquC+c97HPqHBRcc1RBwrMhFnXyDFjSOd7yT7+i8OTbgdcaz35D7cfvtGVRPhYAI8pIKEpOamER9ur6wGutvVc6o+AC9k7Z5V+CyJvZWetLBiHhHpCKIn1be5Jwvxekokj4S9IF93tBJsprb+4G1dhc2VrJam3qx4FMlHr3dJ5qbK60Ek2HOsMwyEThPtVSwPmekIjCeYqlhmtTSyIK5ynWMBgSUThPsdRwvTfkG24GGWgXRdo5DAq2N27mqTP0o10UaecwKFD+2wXqDP2Y0mOIhHZRuDZrnOB4j8yMYoiEEcUQCSOKIRJGFEMkjCiGSBhRDJGYyV3S5p+/D712vlXRmEQO2t/rmcUXvcaF44thpvQYIqFdlNIq9nWPKY3U9SK7Lx2QvFK66doBxbhSeFRVLF717cWUHkMkSEQJ/wGB4b9wvTc0RyHTuTrFuIbLQ1YLKfuUpe9/Rv6bJwOvNTaf4fCXHzQn+gzH/gQg3HCzoDyq/ZSMu47sV18PvNY9e685zWe4lh2AsJm1HZxQjc0VziWZTBQJXxnSDecvRZIuj5MdZQ5af4Jz2QGIRZH4Yd5pwe3ZTj/kG25mVuE/mwAMjhmUDnFQdvWugFq1XTQrfwy85u+91hUDAM8nxYNgsWZ//gCZVsNW1DkoyFwv5B++OGa72gkhLz0A8PAFWhKm30ljQXkSJAGYzCghs3SoSUrJCWElSgBYf7l2lzqHDr6sqmQCuKDOERUWpSckAVxcc1SBOse0SQbOvCRJAGaiAJ92bNPpReoc08IJkrdKtQ+n1DnGhVXp6aWyjNvdlB2rY5PS+pJe2IoCxEsWyZIADEtPL6VDHMShDDlB8pZkSQDmM0rI9gby5759Rp3jMiQDZ15iT9KPCFGAj0vnigtXyj6LBeWVqqhKW90MQ4woIRI25aT3I4MQJwrw8dlQp4FlbsJYUF4BOFqrwqfOMmlEihLCaVUUx1mkF9GihFAKE3dBQmIhSsj2BvLKx8K0S5IF5eWSc+/Wd04/THMcTsRKlF427+aKVruem5Q0FpSXCbL+/VrzaBK/TxqxFaWf4DFS4VezR8kTno0prWI/8RQdHfkMBoNhdvgXbNSIwk+kcVQAAAAASUVORK5CYII=',
        width: 90,
        alignment: 'center'
      };
    }
  }

  DisplayCustomConveniencFee(paymentType: string) {
    this.PoeDataService.getPoeMetaData().subscribe(data => {
      if (!this.util.isEmpty(data)) {
        let resultData = data as MetadataResponse;
        var parseVal = JSON.parse(resultData.metaData) as Metadata;
        if (parseVal.POE.CustomConvenienceFeeLabel != null && parseVal.POE.CustomConvenienceFeeLabel != '') {
          this._customConvenienceFeeLabel = `${parseVal.POE.CustomConvenienceFeeLabel}:`;
          if (paymentType == "CC" && parseVal.POE.CustomConvenienceCC) {
            this._customConvenienceCC = parseVal.POE.CustomConvenienceCC;  
            this.isCustomConvenienceLableShow = true;
          }
          if (paymentType == "ACH" && parseVal.POE.CustomConvenienceFeeACH) {
            this._customConvenienceCC = parseVal.POE.CustomConvenienceFeeACH;
            this.isCustomConvenienceLableShow = true;
          }
        }        
      }
    });
  }


  toDataURL = url => fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    }))

  returntohome() {
      this.ClearMemcache();
      const homeUrl = location.origin;
      window.open(`${homeUrl}/home/${this.uniqueToken}`, '_top');         
    }

}
